import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import Header from "./component/Header";
import FirstTab from "./component/FirstTab";
import ThirdTab from "./component/ThirdTab";
import FourthTab from "./component/FourthTab";
import FiveTab from "./component/FiveTab";
import SixTab from "./component/SixTab";
import SevenTab from "./component/SevenTab";
import EightTab from "./component/EightTab";
import TenTab from "./component/TenTab";
import TwelveTab from "./component/TwelveTab";
import ThirteenTab from "./component/ThirteenTab";
import FourteenTab from "./component/FourteenTab";
import BottamTab from "./component/BottamTab";
import NineTab from "./component/NineTab";
import EarlyDetection from "./component/EarlyDetection";
import BottomNavBar from "./component/BottamNavBar";
import PrivacyPolicy from "./component/PrivacyPolicy";

const App = () => {
  const [showButton, setShowButton] = useState(false);

  const modulesRef = useRef(null);
  const earlyDetectionRef = useRef(null);
  const supportGroupsRef = useRef(null);
  const privacyPolicyRef = useRef(null);
  const doctorDashboardRef = useRef(null);

  const scrollToSection = (section) => {
    console.log("📌 scrollToSection called with:", section);

    let ref = null;
    if (section === "modules") ref = modulesRef;
    if (section === "earlyDetection") ref = earlyDetectionRef;
    if (section === "supportGroups") ref = supportGroupsRef;
    if (section === "privacyPolicy") ref = privacyPolicyRef;
    if (section === "doctorDashboard") ref = doctorDashboardRef;

    if (ref?.current) {
      console.log("✅ Scrolling to section:", section, ref.current);
      ref.current.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn("⚠️ No ref found for section:", section);
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    console.log("⬆️ Back to Top clicked");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const styles = {
    cardContainer: {
      maxWidth: "100%",
      paddingLeft: "20px",
      paddingRight: "20px",
      backgroundColor: "#ffffff",
    },
    backToTopWrapper: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      zIndex: 1000,
      flexDirection: "column",
    },
    backToTopBtn: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "#000",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "20px",
      cursor: "pointer",
      boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
    },
    backToTopText: {
      fontSize: "14px",
      fontWeight: "500",
      color: "#000",
    },
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header scrollToSection={scrollToSection} />
              <FirstTab />

              <div style={styles.cardContainer}>
                <div>
                  <ThirdTab />
                </div>
                <FourthTab />
                <div ref={modulesRef}>
                  <FiveTab />
                </div>
                <SixTab />
                <SevenTab />
                <EightTab />
                <NineTab />
                <TenTab />
                <div ref={earlyDetectionRef}>
                  <EarlyDetection />
                </div>
                <div ref={doctorDashboardRef}>
                  <TwelveTab />
                </div>
                <div ref={supportGroupsRef}>
                  <ThirteenTab />
                </div>
                <div ref={privacyPolicyRef}>
                  <FourteenTab />
                </div>
                <BottamTab />
                <BottomNavBar />
              </div>

              {showButton && (
                <div style={styles.backToTopWrapper} onClick={scrollToTop}>
                  <div style={styles.backToTopBtn}>↑</div>
                  <span style={styles.backToTopText}>Back to Top</span>
                </div>
              )}
            </>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default App;
